import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBroom, faClockRotateLeft, faShieldHeart, faIdBadge } from '@fortawesome/free-solid-svg-icons';

import './Home.scss';

const Home = () => {

  return (
    <>
      <div className="top__screen">
        <h1 className='top__screen__title'>
          Fast repair of <span>air conditioners</span> and commercial refrigeration equipment
        </h1>
        <p className='top__screen__text'>
          Original spare parts for all popular brands <br></br> and repair of any complexity
        </p>
        {/* <button className='top__btn'>Get in touch</button> */}
        <Link className='top__btn' to='mailto:smcold2023@gmail.com'>Get in touch</Link>
      </div>
      <div className='service__section'>
        <h2 className='titleServ'>
          Our Services
        </h2>
        <div className='blocks__section'>
          <div className='leftServ__section'>
            <div className='repair__block'>
              <p className='linkServ'>Repair of Air Conditioners and Commercial Refrigeration Equipment</p>
              <div className="hidden-block">
                <Link className='hidden-link' to='/repair'>More...</Link>
              </div>
            </div>
            <div className='other__blocks'>
              <div className='maintenance__block'>
                <p className='linkServ'>Maintenance Service</p>
                <div className="hidden-block">
                  <Link className='hidden-link' to='/maintenance'>More...</Link>
                </div>
              </div>
              <div className='freezer__block'>
                <p className='linkServ'>Construction of Refrigerated Freezers</p>
                <div className="hidden-block">
                  <Link className='hidden-link' to='/freezer'>More...</Link>
                </div>
              </div>
            </div>
          </div>
          <div className='rightServ__section'>
            <p className='textServ'>Our company has been specializing in air conditioner and refrigeration equipment repair for over 16 years. Although we are newcomers to the U.S. market, we bring extensive expertise gained through years of service. We provide high-quality repair and maintenance services, ensuring that your cooling systems operate efficiently and reliably. Over the years, we have built a strong reputation for delivering prompt and professional service.</p>
            <p className='textServ--primary'>In addition to repair services, we offer comprehensive maintenance programs to extend the lifespan of your equipment. We are also experts in constructing cold storage rooms, offering custom solutions for businesses needing reliable temperature-controlled environments.</p>
          </div>
        </div>
      </div>
      <div className='perks__section'>
        <div className='top__perks'>
          <h3 className='perks__title'>
            Our company
          </h3>
          <p className='perks__subtitle'>will provide you with</p>
        </div>
        <div className='bottom__perks'>
          <div className='perks__item'>
            <div className='icon__item'>
            <FontAwesomeIcon icon={faBroom} className="fa__2x"/>
            </div>
            <div className='content__item'>
              <h4 className='item__title'>Cleanliness</h4>
              <p className='item__text'>Our masters leave no traces of repair after themselves</p>
            </div>
          </div>
          <div className='perks__item'>
            <div className='icon__item'>
            <FontAwesomeIcon icon={faClockRotateLeft} className="fa__2x"/>
            </div>
            <div className='content__item'>
              <h4 className='item__title'>Speed</h4>
              <p className='item__text'>80% of the work is done within an hour</p>
            </div>
          </div>
          <div className='perks__item'>
            <div className='icon__item'>
            <FontAwesomeIcon icon={faShieldHeart} className="fa__2x"/>
            </div>
            <div className='content__item'>
              <h4 className='item__title'>Reliability</h4>
              <p className='item__text'>Repair warranty up to 1 year</p>
            </div>
          </div>
          <div className='perks__item'>
            <div className='icon__item'>
            <FontAwesomeIcon icon={faIdBadge} className="fa__2x"/>
            </div>
            <div className='content__item'>
              <h4 className='item__title'>Professionalism</h4>
              <p className='item__text'>Experience of our specialists for more than 15 years</p>
            </div>
          </div>
        </div>
      </div>
      <div className='about__section'>
          <div className='item__about item__img'>
            <p className='item__about__text'>We have been trusted <span>since 2003</span></p>
          </div>
          <div className='item__about2'>
            <p className='item__about__text2'>We have <span>over 20 years</span> experience in the air conditioning industry</p>
            <p className='item__about__subtext2'>We make sure that the AC repair and AC installation is done by high level professionals</p>
          </div>
          <div className='item__about2'>
            <p className='item__about__text2'>Versatile and <span>cost effective</span> services</p>
            <p className='item__about__subtext2'>We provide quality service at an affordable price and in the shortest time possible</p>
          </div>
          <div className='item__about item__img2'>
            <p className='item__about__text'>8:00 - 22:00</p>
            <Link className='item__num' to='tel:+12153885043'>+1 215 388 50 43</Link>
          </div>
        </div>
    </>
  );
};

export default Home;